var __TEMP__ = require('./_baseIsSet.js');var baseIsSet = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseUnary.js');var baseUnary = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_nodeUtil.js');var nodeUtil = __REQUIRE_DEFAULT__(__TEMP__);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isSet;
